import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export type PrimaryGroupContactsState = {
    primaryGroupContacts?: any[],
};

const initialState: PrimaryGroupContactsState = {
    primaryGroupContacts: []
};

export const primaryGroupContactsSlice = createSlice({
    name: 'primaryGroupContacts',
    initialState,
    reducers: {
        setPrimaryGroupContacts: (state, action: PayloadAction<PrimaryGroupContactsState>) => {
            state.primaryGroupContacts = action.payload.primaryGroupContacts;
        }
    }
});

export const { setPrimaryGroupContacts } = primaryGroupContactsSlice.actions;

export default primaryGroupContactsSlice.reducer;
